import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../../context/tenant-context';
import { v2Component } from '../../../../index';
import { ToastContainer } from 'react-toastify';
import { FuelChargingConfigForm } from './fuel-charging-config';

export function initFuelChargingConfigForm(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('fuel-charging-config-form');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };

      const bootstrap = () => {
        const { tenant, contextPath, productId, ...props } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <FuelChargingConfigForm productId={productId} {...props} setRootAttributes={setRootAttributes} />
            </TenantContext.Provider>,
          ),
        );
        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      };

      bootstrap();
    }
  });
}
